import { useCallback, useEffect } from "react";

import { useOrganizationConfig } from "shared/hooks/useOrganizationConfig";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import { captureException, captureMessage } from "@sentry/nextjs";

export const useUpdateOrganizationInCookieWhenLogin = () => {
  const { loggedUser } = useAuthContext();
  const { saveOrganizationInCookies, getOrganizationFromCookies } =
    useOrganizationConfig();

  const handleUpdateOrganizationInCookieWhenLogin = useCallback(() => {
    try {
      const userIsLogged = !!loggedUser;
      if (!userIsLogged) return;

      const organizationInCookie = getOrganizationFromCookies();

      const updatedOrganization = loggedUser?.subscribed_orgs?.find(
        (subscribedOrg) => subscribedOrg?.id === organizationInCookie?.id,
      );

      const shouldUpdateOrganizationInCookie = !!updatedOrganization;
      if (!shouldUpdateOrganizationInCookie) return;

      saveOrganizationInCookies({
        ...organizationInCookie,
        ...updatedOrganization,
      });
    } catch (error) {
      const errorMessage = "Erro (handleUpdateOrganizationInCookieWhenLogin)";

      console.log(errorMessage, error);
      captureException(error);
      captureMessage(errorMessage);
    }
  }, [loggedUser, saveOrganizationInCookies, getOrganizationFromCookies]);

  useEffect(() => {
    handleUpdateOrganizationInCookieWhenLogin();
  }, [handleUpdateOrganizationInCookieWhenLogin]);

  return {};
};
